import { TeamMemberForm } from "~/components/form/team/TeamMemberForm";
import { Authorize } from "~/components/permission/Authorize";
import { useDismiss } from "~/providers/DismissProvider";

export default function CreateInvite() {
    const { handleDismiss } = useDismiss();

    return (
        <Authorize ability="update" section="team">
            <TeamMemberForm onRequestClose={handleDismiss} asRoute />
        </Authorize>
    );
}
